import React, { FC } from 'react'

import isaacOpus from 'assets/images/logo-opus.png'
import { IArtistInfoProps } from './ArtistInfo.props'

import './ArtistInfo.scss'

const ArtistInfo: FC<IArtistInfoProps> = ({ artistName, opusId, firstCreatedIn, gpsStatus }) => (
  <div className="artist-info">
    <section className="artist-info__section">
      <div className="artist-info__section-item">
        <h6 className="artist-info__title">Artist</h6>
        <p className="artist-info__data">{artistName}</p>
      </div>
      <div className="artist-info__section-item">
        <h6 className="artist-info__title">First Created In</h6>
        <p className="artist-info__data">{firstCreatedIn}</p>
      </div>
    </section>
    <section className="artist-info__section">
      <div className="artist-info__section-item">
        <h6 className="artist-info__title opus">
          OPUS-ID <img className="artist-info__opus-logo" src={isaacOpus} alt="OPUS Logo" />
        </h6>
        <p className="artist-info__data">GRP-{opusId}</p>
      </div>
      <div className="artist-info__section-item">
        <h6 className="artist-info__title">GPS Artist Status</h6>
        <p className="artist-info__data">{gpsStatus}</p>
      </div>
    </section>
  </div>
)

export default ArtistInfo
